import { css } from "@emotion/react";

const MAX_TEXT_INPUT_WIDTH = "600px";
export const MAX_TEXT_INPUT_WIDTH_VAR = "--maxInputWidth";

export const inputStyles = css`
  ${MAX_TEXT_INPUT_WIDTH_VAR}: ${MAX_TEXT_INPUT_WIDTH};
`;
